module.exports = {
  localeName: 'zh-Hant',
  momentFormat: 'YYYY/MM/DD',
  qrCodeUrl: 'https://www.inmoment.com/websurvey/2/begin?gateway=CHNQRCode&base32=surveyCode&CountryCode=156&SurveyType=2&Ereceipt=1&qrcode=5',
  qrCodeUrl2: 'http://www.xfplink.cn/xforce/#/orderinvoice/follow?br=Nike&cpy=47D61F8E7645287627B2AA4265B75DE7BFDCC9C38831053A',
};
